// Disable zone.js patching of 'unload' event to avoid Permissions Policy violations in Chrome
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['unload'];
